module.exports = [{"route":"/app/about","label":"Home","accessKey":"composer","iconCls":"fa fa-fw fa-info"},{"label":"When >> Then","accessKey":"quickstartProgramming","iconCls":"when-then","route":"/app/programming"},{"route":"/app/sysman/disco","label":"System Manager","accessKey":"systemManager","iconCls":"fa fa-fw fa-wrench"}]


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/assets/config/sidebar.json
// module id = 1495
// module chunks = 0